import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';
import { MaterialModule } from 'app/main/material.module';

import { DashboardComponent } from 'app/main/dashboard/dashboard.component';
import { DashboardCardComponent } from 'app/main/dashboard/dashboard-card/dashboard-card.component';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';

import { MomentModule } from 'ngx-moment';
import { AgGridModule } from '@ag-grid-community/angular';
import { FileUploadModule } from 'app/main/file-upload/file-upload.module';
import { DeleteCompanyDialogComponent } from './DeleteCompanyDialog/DeleteCompanyDialog.component';

@NgModule({
    declarations: [
        DashboardComponent,
        DashboardCardComponent,
        DeleteCompanyDialogComponent
    ],
    imports     : [
        FuseSharedModule,
        MaterialModule,
        FileUploadModule,
        
        // AG Grid
        AgGridModule.withComponents([]),

        PageTitleModule,
        MomentModule,
    ],
    exports     : [
        DashboardComponent,
        DashboardCardComponent,
    ],
    entryComponents: [DeleteCompanyDialogComponent],
    providers: [
    ]
})

export class DashboardModule
{
}
